import React from "react";
import { Chart } from "react-google-charts";
import { StaticQuery, graphql } from "gatsby";
import styled from 'styled-components';

const Responsive = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Summary = () => (
  <StaticQuery
    query={query}
    render={({
      allMeetingsYaml,
      allPetitionsYaml,
      allGiinsYaml,
    }) => {
      const giins = allGiinsYaml.edges.reduce((acc, {node}) => {
        acc[node.identifier] = node.name; 
        return acc;
      }, {});
      const speakers = allMeetingsYaml.edges.reduce((acc, {node}) => {
        node.speakers.forEach(({identifier}) => { 
          acc[identifier]= acc[identifier] ? (acc[identifier] + 1) : 1; 
        });
        return acc;
      }, {});
      const topSpeakers = Object.keys(speakers).reduce((acc, current) => {
        return acc.concat([[giins[current], speakers[current]]]);
      }, []).sort((a, b) => { return b[1] - a[1]; });
      
      const referrers = allPetitionsYaml.edges.reduce((acc, {node}) => {
        node.giins.forEach((identifier) => { 
          acc[identifier]= acc[identifier] ? (acc[identifier] + 1) : 1; 
        });
        return acc;
      }, {});
      const topReferrers = Object.keys(referrers).reduce((acc, current) => {
        return acc.concat([[giins[current], referrers[current]]]);
      }, []).sort((a, b) => { return b[1] - a[1]; })
      
      return (
        <Responsive>
          <div>
            <Chart
              width={'600px'}
              height={'600px'}
              chartType={'BarChart'}
              loader={<div>Loding...</div>}
              data={
                [['name', '回数']].concat(topSpeakers) 
              }
              options={{
		chartArea: { height: '80%' },
		legend: { position: 'none' },
                title: '議会での質問回数',
                hAxis: {
                  title: '質問回数',
                  minValue: 0,
                },
                vAxis: {
                  title: '議員',
                }
              }}
            />
          </div>
          <div>
            <Chart
              width={'600px'}
              height={'500px'}
              chartType={'BarChart'}
              loader={<div>Loding...</div>}
              data={
                [['name', '件数']].concat(topReferrers) 
              }
              options={{
		chartArea: { height: '80%' },
		legend: { position: 'none' },
                title: '請願の紹介件数',
                hAxis: {
                  title: '紹介件数',
                  minValue: 0,
                },
                vAxis: {
                  title: '議員',
                }
              }}
            />
          </div>
        </Responsive>
      );
    }}
  />
);

export default Summary;

const query = graphql`
  query {
    allMeetingsYaml(sort: {order: DESC, fields: convocation_date}, filter: {fields: {current: {eq: true}}}) {
      edges {
        node {
          title
          convocation_date
          speakers {
            identifier
            url
          }
        }
      }
    }
    allPetitionsYaml(filter: {fields: {current: {eq: true}}}) {
      edges {
        node {
          giins
        }
      }
    }
    allGiinsYaml(filter: {fields: {current: {eq: true}}}) {
      edges {
        node {
          identifier
          name
        }
      }
    } 
  }
`;
